import { Expose } from "class-transformer";

export class UpdateAntiFallPpeTypeDto {
  @Expose()
  name: string;
}
